<template>
    <v-app-bar app color="primary" clipped-left dark>
      <span class="mx-2">MIT.nano Argh!</span
      ><v-divider vertical class="mx-2"></v-divider>
      <span>Submit Feedback about Everyday Lab Issues</span>
      <v-spacer></v-spacer>
      <v-divider vertical class="mx-2"></v-divider>
      <v-btn class="mx-2" text fab small @click.stop="showHelp()">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <v-divider vertical class="mx-2"></v-divider>
    </v-app-bar>
  </template>
  
  <script>
  import HelpDialog from "@/support/helpMessage";
  export default {
    data: () => ({}),
    methods: {
      async showHelp() {
        const aMessage = HelpDialog.GetHelpMessage();
        await this.$root.$confirmdialog("About - MIT.nano Argh!", aMessage, {
          color: "secondary",
          reject: "",
          accept: "Okay",
        });
      },
    },
  };
  </script>
  
  